import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ icon, title, value, trendValue, trendUp }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-4 flex flex-col justify-between transition-smooth hover:shadow-elevation-md">
      <div className="flex items-start justify-between">
        <div className="bg-primary/10 p-2 rounded-lg">
          <Icon name={icon} size={20} className="text-primary" />
        </div>
        {trendValue && (
          <div className={`flex items-center gap-1 px-2 py-0.5 rounded-md ${
            trendUp ? 'bg-success/10 text-success' : 'bg-muted text-muted-foreground'
          }`}>
            <Icon name={trendUp ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span className="text-xs font-medium">{trendValue}</span>
          </div>
        )}
      </div>
      <div>
        <p className="text-2xl md:text-3xl font-semibold text-foreground mt-3">
          {value ?? '-'}
        </p>
        <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
          {title}
        </h3>
      </div>
    </div>
  );
};

export default MetricsCard;